import {
    Button,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../settings/inputConfig";
import { useEffect, useState } from "react";

import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { fnEmpty } from "../../settings/preventConfig";

export default function MeditocTableSelection(props) {
    const { data, setData, columns, id, rows, setRows, addRows, trigger } = props;

    const [selectAll, setSelectAll] = useState(false);

    const pager = [10, 50, 200, 500, 2000];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pager[0]);
    const [dataRows, setDataRows] = useState([]);
    const [filters, setFilters] = useState({});
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState(true);

    //Crear objecto de filtro
    useEffect(() => {
        const filterObj = {};
        columns.forEach((column) => {
            filterObj[column.field] = "";
        });
        setFilters(filterObj);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const dataTemp = data.map((row) => ({
            ...row,
            rowSelected: !row.rowSelected ? false : row.rowSelected,
        }));
        setDataRows(dataTemp);
        setData(dataTemp);
        // eslint-disable-next-line
    }, [trigger]);

    //Filtrar al escribir
    useEffect(() => {
        const keys = Object.keys(filters);
        const values = Object.values(filters);

        if (keys.length > 0) {
            if (values.every((x) => x === "")) {
                setDataRows(data);
            } else {
                let filterList = [...data];

                keys.forEach((key, i) => {
                    const filterText = values[i].trim().toUpperCase();

                    if (filterText !== "") {
                        filterList = filterList.filter((x) => {
                            return x[key].toString().toUpperCase().includes(filterText);
                        });
                    }
                });
                setDataRows(filterList);
            }
        }
        // eslint-disable-next-line
    }, [filters]);

    if (!columns) {
        return;
    }

    if (!dataRows) {
        return;
    }

    if (typeof setRows !== "function") {
        return;
    }

    //Cambiar de pagina
    const handleChangePage = (e, page) => {
        setPage(page);
    };

    //Cambiar las filas por pagina
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setPage(0);
    };

    //Capturar al escribir en los filtros
    const handleChangeFilter = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });
        setPage(0);
    };

    //Ordenar tabla
    const handleClickOrder = (field) => {
        const orderField = field === orderBy ? !order : order;

        let orderList = [];
        if (orderField) {
            orderList = dataRows.sort((a, b) => (a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0));
        } else {
            orderList = dataRows.sort((a, b) => (a[field] < b[field] ? 1 : a[field] > b[field] ? -1 : 0));
        }

        setDataRows(orderList);

        if (field === orderBy) {
            setOrder(orderField);
        } else {
            setOrderBy(field);
        }
    };

    const handleClickRow = (e, dataRow) => {
        e.stopPropagation();
        const rowIndex = rows.map((x) => x[id]).indexOf(dataRow[id]);
        const rowsCopy = [...rows];

        if (rowIndex === -1) {
            rowsCopy.push(dataRow);
        } else {
            rowsCopy.splice(rowIndex, 1);
        }
        setSelectAll(rowsCopy.length === data.length);
        setRows(rowsCopy);

        const listTemp = data.map((row) => ({
            ...row,
            rowSelected: row[id] === dataRow[id] ? rowIndex === -1 : !row.rowSelected ? false : row.rowSelected,
        }));

        setData(listTemp);

        setDataRows(listTemp.filter((row) => dataRows.map((y) => y[id]).includes(row[id])));
    };

    const handleChange = (e, dataRow, column) => {
        e.stopPropagation();
        let value = e.target.value;

        switch (column.type) {
            case "int":
                if (value !== "" && value !== "-" && value !== "0" && value % 1 !== 0) {
                    return;
                }
                value = value !== "" && value !== "-" ? parseInt(value) : "";
                break;

            case "uint":
                if (value !== "" && value !== "0" && value % 1 !== 0) {
                    return;
                }
                value = value !== "" ? parseInt(value) : "";
                break;

            case "dec":
                if (isNaN(value) && value !== "" && value !== "-") {
                    return;
                }
                value = value !== "" && value !== "-" ? parseFloat(value) : "";
                break;

            case "udec":
                if (isNaN(value) && value !== "") {
                    return;
                }
                value = value !== "" ? parseFloat(value) : "";
                break;

            default:
                break;
        }

        const rowIndex = rows.map((x) => x[id]).indexOf(dataRow[id]);
        const rowsCopy = [...rows];

        const rowTemp = {
            ...dataRow,
            [column.field]: value,
        };

        if (rowIndex === -1) {
            rowsCopy.push(rowTemp);
        } else {
            rowsCopy.splice(rowIndex, 1);
            rowsCopy.push(rowTemp);
        }
        setSelectAll(rowsCopy.length === data.length);
        setRows(rowsCopy);

        const listTemp = data.map((row) => ({
            ...row,
            [column.field]: row[id] === dataRow[id] ? value : row[column.field],
            rowSelected: row[id] === dataRow[id] ? true : !row.rowSelected ? false : row.rowSelected,
        }));

        setData(listTemp);

        setDataRows(listTemp.filter((row) => dataRows.map((y) => y[id]).includes(row[id])));
    };

    const handleClickSelectAll = (select) => {
        const listTemp = data.map((row) => ({
            ...row,
            rowSelected: select,
        }));
        setRows(select ? listTemp : []);

        setData(listTemp);

        setDataRows(listTemp.filter((row) => dataRows.map((y) => y[id]).includes(row[id])));

        setSelectAll(select);
    };

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Tooltip arrow title="Seleccionar todo" placement="top">
                                <Checkbox
                                    checked={selectAll}
                                    style={{ padding: "0px" }}
                                    onClick={() => handleClickSelectAll(!selectAll)}
                                />
                            </Tooltip>
                        </TableCell>
                        {columns.map((column, i) => (
                            <TableCell key={i}>
                                {!column.hideSort && (
                                    <Button
                                        startIcon={
                                            orderBy === column.field ? (
                                                order ? (
                                                    <ArrowUpwardIcon />
                                                ) : (
                                                    <ArrowDownwardIcon />
                                                )
                                            ) : (
                                                <ArrowUpwardIcon />
                                            )
                                        }
                                        color={orderBy === column.field ? "primary" : "default"}
                                        onClick={() => handleClickOrder(column.field)}
                                    >
                                        {column.title}
                                    </Button>
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody style={{ whiteSpace: "nowrap" }}>
                    <TableRow>
                        <TableCell></TableCell>
                        {columns.map((column, i) => (
                            <TableCell key={i}>
                                {!column.hideFilter && (
                                    <TextField
                                        variant={inputVariant}
                                        color={inputColor}
                                        name={column.field}
                                        fullWidth
                                        placeholder={"Buscar en " + column.title + "..."}
                                        onChange={handleChangeFilter}
                                        autoComplete="off"
                                        value={!filters[column.field] ? "" : filters[column.field]}
                                        size="small"
                                    />
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                    {dataRows.length > 0 ? (
                        dataRows.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((dataRow, i) => (
                            <TableRow
                                key={i}
                                style={{
                                    backgroundColor: dataRow.rowSelected ? "#eeeeee" : "#fff",
                                    cursor: "pointer",
                                }}
                            >
                                <TableCell>
                                    <Checkbox
                                        checked={!dataRow.rowSelected ? false : dataRow.rowSelected}
                                        style={{ padding: "0px" }}
                                        onClick={(e) => handleClickRow(e, dataRow)}
                                    />
                                </TableCell>
                                {columns.map((column, j) => (
                                    <TableCell
                                        key={j}
                                        onClick={!column.edit ? (e) => handleClickRow(e, dataRow) : fnEmpty}
                                    >
                                        {column.edit ? (
                                            <TextField
                                                variant="standard"
                                                color={inputColor}
                                                fullWidth
                                                size="small"
                                                value={dataRow[column.field]}
                                                onChange={(e) => handleChange(e, dataRow, column)}
                                                inputProps={{ style: { textAlign: "center" } }}
                                            />
                                        ) : (
                                            dataRow[column.field]
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columns.length + 1} align="center">
                                <Typography>No se encontraron registros para mostrar</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                    {addRows}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            count={dataRows.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={pager}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
